// Style number can be on both /styles/? (legacy) and /bill-of-materials/?
const styleNumberRegex = /\/(styles|bill-of-materials)\/(\d+)/;

const extractStyleNumberParam = (): number | undefined => {
    // We cannot use useParams everywhere, because that only works inside a Route and we need it outside too
    const match = styleNumberRegex.exec(location.pathname);
    /**
     * match[0] = full path
     * match[1] = /styles or /bill-of-materials
     * match[2] = :styleNumber
     */
    const styleNumber = match ? Number.parseInt(match[2]) : undefined;
    return styleNumber;
};

export { extractStyleNumberParam };
